// extracted by mini-css-extract-plugin
export var aiStarIcon = "_9h-4";
export var closeButton = "_9h-6";
export var dismissButton = "_9h-3";
export var editImageWithAiContainer = "_9h-8";
export var imageUploadWrapper = "_9h-7";
export var misspelledWord = "_9h-5";
export var spellCheckContainer = "_9h-2";
export var spin = "_9h-1";
export var spinning = "_9h-0";